/* jshint esnext: true */

/**
 * dropdown in dropdown
 ***********************/
new Vue({
  el: '#dropdown-newTopics',
  template: '#dropdown-newTopics-template',

  data: {
    settings: {
      urlPrefixesPath: "./data/newTopics-prefixes.json",
      jsonPath: './data/newTopics.json'
    },
    prefixed: [],
    raw: []
  },
  created: function() {
    let _this = this;
    // get json file
    $.ajax({
      url: this.settings.jsonPath,
      dataType: 'json'
    }).done(data => {
      _this.raw = data.slice(0, 4);
    }).done(() => {
      setPrefix();
    });

    function setPrefix() {
      return $.ajax({
        url: _this.settings.urlPrefixesPath,
        dataType: 'json'
      }).done(data => {
        let currentHost = window.location.host;
        let urlPrefixes = data[currentHost];

        _this.prefixed = $.map(_this.raw, el => {
          var urlPattern = /^https?:\/\//i;
          if (!el.url.match(urlPattern)) {
            el.url = urlPrefixes.url_before + el.url + urlPrefixes.url_after;
          }

          return el;
        });

      });
    }
  }
});
